import { render, staticRenderFns } from "./pitches.vue?vue&type=template&id=6065d7d4&scoped=true&"
import script from "./pitches.vue?vue&type=script&lang=js&"
export * from "./pitches.vue?vue&type=script&lang=js&"
import style0 from "./pitches.vue?vue&type=style&index=0&id=6065d7d4&scoped=true&lang=css&"
import style1 from "./pitches.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6065d7d4",
  null
  
)

export default component.exports